// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
export const CustomerContextKey = {
    userContext: 'userContext',
    globalContext: 'globalContext',
    accountContext: 'accountContext',
};
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
export const ContextManagerMethod = {
    getContext: 'getContext',
    setContext: 'setContext',
    setContextProperty: 'setContextProperty',
    removeContextProperty: 'removeContextProperty',
    clearContext: 'clearContext',
};
//# sourceMappingURL=contextConstants.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum-core/~/@datadog/browser-core/esm/domain/context/contextConstants.js